import React from 'react'
import styles from "./PhoneLink.module.scss";
function PhoneLink( {phoneNumber} : {phoneNumber: string} ) {
    return (
        <a className={styles.number} href={`tel:${phoneNumber}`} dir="ltr">{phoneNumber}</a>
      );
}

export default PhoneLink